const componentSide = {
  left: "LEFT",
  right: "RIGHT",
};
const helperTexts = {
  processingMode:
    "Text mode tries to extract text from PDF and falls to OCR if the PDF is a scanned image PDF. This should be your default selection. Use OCR mode if you want to force OCR to extract text. This could be useful if you are dealing with malformed PDFs.",
  outputMode:
    "The output format. Valid options are line-printer, dump-text and text. The line-printer mode tries to maintain the layout of the original text and works very well as inputs to LLMs. dump-text just dumps each page as paragraphs. text extracts text into groups as it sees in the original page. text and dump-text are treated as same in ocr processing mode.",
  forceTextProcessing:
    "If checked, ensures that only text processing runs and there is no OCR involved. This differs from the default behaviour where we fall back to OCR processing in case of failures with text processing.",
};

const formFieldValues = {
  processingMode: "processing_mode",
  outputMode: "output_mode",
  forceTextProcessing: "force_text_processing",
  file: "file",
  secretResponse: "secret_response",
};

const processingModeOptions = [
  {
    value: "form",
    label: "Form",
  },
  {
    value: "native_text",
    label: "Native Text",
  },
  {
    value: "low_cost",
    label: "Low Cost",
  },
  {
    value: "high_quality",
    label: "High Quality",
  },
];

const outputModeOptions = [
  {
    value: "line-printer",
    label: "Layout Preserving (LLM Friendly)",
  },
  {
    value: "text",
    label: "Text",
  },
];

const backgroundColors = {
  white: "#ffffff",
  disable: "#e2e2e2",
};

export {
  componentSide,
  helperTexts,
  formFieldValues,
  processingModeOptions,
  outputModeOptions,
  backgroundColors,
};
